import { API } from "@/utils/api";
import { CreateTask, RerunTaskPayload } from "@/types";
import { TASK_PAGE_SIZE } from "@/config";

/* Get all tasks of current user */
export const getAllTasks = async (
  showArchived: boolean = false,
  offset: number = 0,
  size: number = TASK_PAGE_SIZE,
) => {
  const response = await API().get(
    `/tasks?offset=${offset}&size=${size}&showarchived=${showArchived}`,
  );
  return response.data.data;
};

/* Get information for a certain task */
export const getTaskById = async (taskId: string) => {
  const response = await API().get(`/task/${taskId}`);
  return response.data.data.task;
};

/* Download SARIF report */
export const getSarif = async (taskId: string) => {
  const response = await API().get(`/sarif/${taskId}`);
  return response.data.data.report;
};

/* Download PDF report */
export const getPdf = async (taskId: string) => {
  try {
    const response = await API({ responseType: "blob" }).get(`/pdf/${taskId}`);
    return response.data;
  } catch (err: any) {
    const data = await err.response.data.text();
    throw new Error(JSON.parse(data).message);
  }
};

/* Create a new task */
export const createTask = async ({ taskName, code, githubUrl }: CreateTask) => {
  let formData = new FormData();
  formData.append("taskName", taskName);
  githubUrl && formData.append("githubUrl", githubUrl);
  code && formData.append("code", code);

  const response = await API().post(`/task`, formData);
  return response.data.data.task;
};

/* Start running a task */
export const runTaskById = async (taskId: string) => {
  const response = await API().post(`/task/${taskId}/_run`);
  return response.data.data.task;
};

/* Rerun a task */
export const reRunTaskById = async ({
  taskId,
  code,
  githubUrl,
  taskName,
}: RerunTaskPayload) => {
  let formData = new FormData();
  formData.append("taskName", taskName);
  githubUrl && formData.append("githubUrl", githubUrl);
  code && formData.append("code", code);

  const response = await API().put(`/task/${taskId}`, formData);
  return response.data.data.task;
};

/* Archive a task */
export const archiveTaskById = async (taskId: string, isArchived: boolean) => {
  const response = await API().put(`/task/${taskId}/_archive`, {
    isArchived,
  });
  return response.data.data;
};
